import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetUserOfSuscriber = async (refId) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('subscribers') + '/getUsersSubscriberCorpEntities'

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      clicod: refId,
      offset: 0,
      limit: 100
    }
  })
}
